module.exports = __webpack_public_path__ + "static/media/Snapchat.b1ad107c.png";